module.exports = __webpack_public_path__ + "static/cars_night-6c2909c21b7f9c6102544592d0499530.jpg";